var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.167969 31.5C0.167969 14.4712 13.9725 0.666626 31.0013 0.666626C48.0301 0.666626 61.8346 14.4712 61.8346 31.5C61.8346 48.5287 48.0301 62.3333 31.0013 62.3333C13.9725 62.3333 0.167969 48.5287 0.167969 31.5ZM31.0007 19.1666C31.0007 17.4638 29.6202 16.0833 27.9173 16.0833C26.2144 16.0833 24.834 17.4638 24.834 19.1666V34.5833C24.834 36.2862 26.2144 37.6666 27.9173 37.6666H43.334C45.0369 37.6666 46.4173 36.2862 46.4173 34.5833C46.4173 32.8804 45.0369 31.5 43.334 31.5H31.0007V19.1666Z",
    fill: "#E9BE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.18b8da88c79896914782fad8f6693419.svg";
export { ForwardRef as ReactComponent };